<template>
  <div class="model-price-table-panel">
    <div class="model-price-long-context-tip">
      长上下文计费说明：单次请求的输入超过 272K 时，输入按 2 倍、缓存读取按 2 倍、输出按 1.5 倍计费。
    </div>
    <div class="model-price-table-wrap">
      <el-table
        v-loading="loading"
        :data="models"
        class="dashboard-table model-price-table"
        empty-text="暂无可用模型"
      >
        <el-table-column prop="model" label="模型" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="首字平均耗时" width="110" align="right">
          <template slot-scope="scope">
            {{ formatElapsed(scope.row.averageFirstTokenElapsedMillis) }}
          </template>
        </el-table-column>
        <el-table-column label="模型可用率" width="110" align="right">
          <template slot-scope="scope">
            <span class="model-availability-rate">{{ formatAvailabilityRate(scope.row.availabilityRate) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="价格 / 1M" min-width="300">
          <template slot-scope="scope">
            <div class="model-price-list">
              <span>输入 {{ formatPrice(scope.row.inputPricePerMillion) }}</span>
              <span>写缓存 {{ formatPrice(scope.row.cacheCreationPricePerMillion) }}</span>
              <span>读缓存 {{ formatPrice(scope.row.cacheReadPricePerMillion) }}</span>
              <span>输出 {{ formatPrice(scope.row.outputPricePerMillion) }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="model-price-note">
      价格单位：USD / 1M。Codex 写缓存按对应单价计入当前用量金额。
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelPriceTable',
  props: {
    models: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatPrice(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) {
        return '-';
      }
      if (number === 0) {
        return '不支持';
      }
      return '$' + number.toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
    },
    formatElapsed(value) {
      if (value === null || value === undefined || value === '') {
        return '暂无数据';
      }
      const millis = Number(value);
      if (!Number.isFinite(millis) || millis < 0) {
        return '暂无数据';
      }
      if (millis < 1000) {
        return Math.round(millis) + '毫秒';
      }
      return (millis / 1000).toFixed(2).replace(/0+$/, '').replace(/\.$/, '') + '秒';
    },
    formatAvailabilityRate(value) {
      if (value === null || value === undefined || value === '') {
        return '100%';
      }
      const rate = Number(value);
      return Number.isFinite(rate) ? rate + '%' : '100%';
    }
  }
};
</script>

<style>
.model-price-table .cell {
  white-space: nowrap;
}

.model-price-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 2px 18px;
  line-height: 1.7;
}

.model-price-long-context-tip {
  margin-bottom: 12px;
  padding: 10px 12px;
  color: #8a5a00;
  background: #fff8e8;
  border: 1px solid #f2d49b;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
}

.model-price-note {
  margin-top: 12px;
  color: #71838d;
  font-size: 12px;
  line-height: 1.6;
}

.model-availability-rate {
  color: #0f856e;
  font-weight: 600;
}

.model-price-table-wrap {
  overflow-x: auto;
}
</style>
